<ng-container *ngLet="delivery$ | async">
  <div class="h4">
    @if (!deliveryLoading) {
      <a class="hyperlink" (click)="downloadPdf(documentId)" href="javascript:void(0)">Delivery #: {{documentId}}</a>
    }
  </div>
</ng-container>
